import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {setAmplitudePhoneVerifiedUserProperty} from "./set_amplitude_phone_verified_user_property";

enum UserAmplitudeEvent {
    PHONE_VERIFIED = "phone_verified"
}

export enum UserAmplitudePhoneVerifiedLocation {
    REGISTRATION = "registration",
    LOGIN = "login"
}

/**
 * User Amplitude tracking entry point.
 *
 * Follows the same convention as AuthAmplitudeTracker: a single class per domain
 * with static methods for each event.
 */
export class UserAmplitudeTracker {
    static phoneVerified(location?: UserAmplitudePhoneVerifiedLocation | false) {
        trackAmplitudeEvent(UserAmplitudeEvent.PHONE_VERIFIED, {...(location && {location})});
        setAmplitudePhoneVerifiedUserProperty(true);
    }
}
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {setAmplitudePhoneVerifiedUserProperty} from "./set_amplitude_phone_verified_user_property";

enum UserAmplitudeEvent {
    PHONE_VERIFIED = "phone_verified"
}

export enum UserAmplitudePhoneVerifiedLocation {
    REGISTRATION = "registration",
    LOGIN = "login"
}

/**
 * User Amplitude tracking entry point.
 *
 * Follows the same convention as AuthAmplitudeTracker: a single class per domain
 * with static methods for each event.
 */
export class UserAmplitudeTracker {
    static phoneVerified(location?: UserAmplitudePhoneVerifiedLocation | false) {
        trackAmplitudeEvent(UserAmplitudeEvent.PHONE_VERIFIED, {...(location && {location})});
        setAmplitudePhoneVerifiedUserProperty(true);
    }
}
